import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { DevTokenPage } from './dev/dev-token-page/dev-token-page';
import { authGuard } from './guards/auth-guard';
import { missionGuard } from './guards/mission-guard';
import { NotAuthorized } from './not-authorized/not-authorized';
import { AccessPage } from './player/access-page/access-page';
import { BriefingPage } from './player/briefing-page/briefing-page';
import { DebriefPage } from './player/debrief-page/debrief-page';
import { EnrollPage } from './player/enroll-page/enroll-page';
import { HomePage } from './player/home-page/home-page';
import { MissionPage } from './player/mission-page/mission-page';
import { NotFoundPage } from './player/not-found-page/not-found-page';
import { PublicOperationPage } from './player/public-operation-page/public-operation-page';
import { VictoryPage } from './player/victory-page/victory-page';

// Outils de developpement : uniquement quand un template de token de dev est
// configure (environnement local).
const devRoutes: Routes = environment.devTokenTemplate
  ? [{ path: 'dev/token', component: DevTokenPage, canActivate: [authGuard] }]
  : [];

// Les parametres de route arrivent dans les entrees des pages (withComponentInputBinding).
export const routes: Routes = [
  ...devRoutes,
  { path: '', component: HomePage, title: 'Killer Party' },

  // Joueur (lot 11)
  { path: 'operations', redirectTo: '', pathMatch: 'full' },
  {
    path: 'operations/:operationId/agents',
    component: EnrollPage,
    title: 'Inscription · Killer Party',
  },
  {
    path: 'operations/:operationId/victory',
    component: VictoryPage,
    title: 'Rapport final · Killer Party',
  },
  {
    path: 'operations/:operationId',
    component: PublicOperationPage,
    title: 'Opération · Killer Party',
  },
  { path: 'missions/:missionId/access', component: AccessPage, title: 'Accès · Killer Party' },
  {
    path: 'missions/:missionId/briefing',
    component: BriefingPage,
    canActivate: [missionGuard],
    data: { page: 'briefing' },
    title: 'Salle de briefing · Killer Party',
  },
  {
    path: 'missions/:missionId/mission',
    component: MissionPage,
    canActivate: [missionGuard],
    data: { page: 'mission' },
    title: 'Ordre de mission · Killer Party',
  },
  {
    path: 'missions/:missionId/debrief',
    component: DebriefPage,
    canActivate: [missionGuard],
    data: { page: 'debrief' },
    title: 'Salle de débriefing · Killer Party',
  },
  // Sans ecran propre : le garde mene a celui du statut de la mission.
  { path: 'missions/:missionId', canActivate: [missionGuard], children: [] },

  // Organisateur (lot 12) : charge a la demande, les joueurs n'en ont pas besoin.
  {
    path: 'login',
    loadComponent: () => import('./login-page/login-page').then((m) => m.LoginPage),
    title: 'Connexion · Quartier général',
  },
  {
    path: 'operation-settings',
    loadComponent: () =>
      import('./admin/operations-page/operations-page').then((m) => m.OperationsPage),
    canActivate: [authGuard],
    title: 'Opérations · Quartier général',
  },
  {
    path: 'operation-settings/new',
    loadComponent: () =>
      import('./admin/new-operation-page/new-operation-page').then((m) => m.NewOperationPage),
    canActivate: [authGuard],
    title: 'Nouvelle opération · Quartier général',
  },
  {
    path: 'operation-settings/:operationId',
    loadComponent: () =>
      import('./admin/operation-settings-page/operation-settings-page').then(
        (m) => m.OperationSettingsPage,
      ),
    canActivate: [authGuard],
    title: "Paramètres d'opération · Quartier général",
  },
  {
    path: 'actions',
    loadComponent: () =>
      import('./actions/actions-list-page/actions-list-page').then((m) => m.ActionsListPage),
    canActivate: [authGuard],
    title: "Catalogue d'actions · Quartier général",
  },
  {
    path: 'actions/categories-tags',
    loadComponent: () =>
      import('./actions/action-taxonomy-page/action-taxonomy-page').then(
        (m) => m.ActionTaxonomyPage,
      ),
    canActivate: [authGuard],
    title: 'Catégories et tags · Quartier général',
  },

  { path: 'not-authorized', component: NotAuthorized, title: 'Accès refusé · Killer Party' },
  { path: 'not-found', component: NotFoundPage, title: 'Dossier introuvable · Killer Party' },
  { path: '**', component: NotFoundPage, title: 'Dossier introuvable · Killer Party' },
];
